// Copyright (c) 2016 Deere & Company

import './new-status-info.scss';
import React, {PropTypes} from 'react';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import LocationUnknownStatusDetails from './additional-fields-views/location-unknown-status-details';
import StatusChange from '@deere/cps-it.warranty-model-factory/lib/status-change';
import StolenStatusDetails from './additional-fields-views/stolen-status-details';
import stolenStatuses from '../utils/stolen-statuses';

const StatusChangeDetails = ({countries, onItemChange, statesInCountry, statusChangeRequest}) =>
    <div>
        {stolenStatuses.includes(statusChangeRequest.newStatus.key) ?
            <StolenStatusDetails
                countries={countries}
                onItemChange={onItemChange}
                statesInCountry={statesInCountry}
                statusChangeRequest={statusChangeRequest}
            /> : null}

        {statusChangeRequest.newStatus.key === 'LCUK' ?
            <LocationUnknownStatusDetails
                onItemChange={onItemChange}
                statusChangeRequest={statusChangeRequest}
            /> : null}
    </div>;

StatusChangeDetails.displayName = 'StatusChangeDetails';
StatusChangeDetails.propTypes = {
    countries: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    onItemChange: PropTypes.func.isRequired,
    statesInCountry: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    statusChangeRequest: PropTypes.instanceOf(StatusChange).isRequired
};

export default StatusChangeDetails;



// WEBPACK FOOTER //
// ./src/product/status-change-request/components/status-change-details.js